// extracted by mini-css-extract-plugin
export default {"root":"LoadingCover_root__lB02j","cover":"LoadingCover_cover__OmhOi","loader":"LoadingCover_loader__qp6Yl","glass":"LoadingCover_glass__amdJt","active":"LoadingCover_active__CMQUk"};